import React from 'react'

import { Button, ButtonProps } from '../..'

type SlidingPanelButtonProps = Pick<ButtonProps, 'onClick'> & React.PropsWithChildren

export const SlidingPanelButton: React.FC<SlidingPanelButtonProps> = ({ children, onClick }) => {
  return <Button onClick={onClick}>{children}</Button>
}
